

<!--[@fadeAnimation]="o.isActivated ? o.activatedRoute : ''"-->
<section [@fadeAnimation]="outlet.isActivated ? outlet.activatedRoute : ''" id="wrapper">
  <router-outlet #outlet="outlet"></router-outlet>
</section>
<app-nav></app-nav>
